export default __webpack_public_path__ + "static/media/787.d758f628.jpg";